import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import TopupGiftPopup from "../TopupGiftPopup";
import NotificationsPopup from "../NotificationsPopup";
import ProfileCard from "../ProfileCard";
import "./Header.css";

const Header = () => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [openTopupPopup, setOpenTopupPopup] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState("");
  const { cartItems } = useSelector((state) => state.cart);
  const history = useHistory();

  const handleHeaderIconClick = (name) => {
    history.push(`/${name}`);
  };

  const handleSearch = (e) => {
    if (window.location.pathname.split("/")[1] !== "images") {
      e.preventDefault();
      history.push(`/search/${search}`);
    } else {
      history.push(`/images/search/${search}`);
    }
  };

  useEffect(() => {
    window.onclick = (e) => {
      if (e.target.closest(".header__notification") === null) {
        setShowNotifications(false);
      }
    };

    setPage(history.location.pathname.substr(1));

    window.onclick = () => {
      setPage(history.location.pathname.substr(1));
    };
  }, [history]);

  return (
    <header className="flex-row">
      <div className="header__left flex-row">
        <div className="header__balance flex-row">
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.618"
              d="M20.1174 8.98181C20.1415 9.25758 20.11 9.51317 20.0229 9.7486C19.939 9.98033 19.8075 10.1844 19.6284 10.3607C19.4493 10.537 19.2242 10.6838 18.9532 10.8011C18.6821 10.9183 18.3748 10.9983 18.0312 11.0411L18.0154 12.1716C18.0137 12.1925 18.0085 12.212 17.9996 12.23C17.9945 12.2512 17.9804 12.2678 17.9571 12.28C17.9342 12.2956 17.9006 12.3085 17.8563 12.3187C17.8155 12.3286 17.7606 12.3362 17.6916 12.3413C17.6122 12.3472 17.5479 12.3467 17.4987 12.34C17.4533 12.3364 17.4161 12.3288 17.3873 12.317C17.3588 12.3087 17.3383 12.2929 17.3259 12.2695C17.3171 12.2494 17.315 12.2252 17.3195 12.1971L17.341 11.0715C17.1736 11.0631 17.0177 11.0486 16.8736 11.0281C16.7291 11.0041 16.5999 10.9772 16.4862 10.9475C16.3725 10.9178 16.2741 10.8852 16.1911 10.8497C16.1116 10.814 16.0514 10.7803 16.0104 10.7486C15.9726 10.7132 15.9442 10.6668 15.9253 10.6092C15.9064 10.5516 15.8924 10.4711 15.8833 10.3677C15.8767 10.2919 15.8747 10.2296 15.8774 10.1808C15.8798 10.1286 15.8866 10.0865 15.8976 10.0544C15.9084 10.0189 15.9237 9.99524 15.9435 9.98336C15.9665 9.96778 15.9935 9.95884 16.0245 9.95654C16.0694 9.95322 16.1355 9.97434 16.2228 10.0199C16.3099 10.062 16.4234 10.1091 16.5634 10.1612C16.7065 10.2096 16.8787 10.2523 17.0799 10.2894C17.2811 10.3265 17.5197 10.3349 17.7958 10.3144C18.2858 10.2781 18.6483 10.1541 18.8833 9.94237C19.1218 9.7304 19.2266 9.45897 19.1977 9.12806C19.1799 8.92468 19.1186 8.75923 19.0137 8.63171C18.9085 8.50073 18.774 8.39274 18.6103 8.30774C18.4497 8.21903 18.2681 8.1475 18.0654 8.09314C17.8658 8.03507 17.6611 7.9774 17.4511 7.9201C17.2447 7.86255 17.039 7.79453 16.8342 7.71604C16.6329 7.6373 16.4502 7.53461 16.2863 7.40799C16.1225 7.28136 15.9854 7.12327 15.875 6.93369C15.7644 6.74067 15.6964 6.49939 15.6711 6.20984C15.6509 5.97889 15.6718 5.76051 15.7337 5.5547C15.7956 5.34889 15.8994 5.16599 16.0452 5.006C16.1907 4.84257 16.3801 4.70536 16.6136 4.59439C16.8467 4.47997 17.1228 4.40052 17.4419 4.35605L17.4542 3.30393C17.4558 3.28299 17.4593 3.26365 17.4647 3.2459C17.4733 3.22445 17.489 3.20594 17.512 3.19036C17.5349 3.17478 17.5669 3.16374 17.608 3.15722C17.6488 3.14726 17.7055 3.13959 17.7779 3.13422C17.8539 3.12859 17.9163 3.12743 17.9652 3.13074C18.0175 3.1338 18.0566 3.14305 18.0822 3.1585C18.111 3.17024 18.1298 3.18619 18.1385 3.20636C18.1472 3.22653 18.1528 3.25041 18.1552 3.27798L18.1317 4.32053C18.2361 4.32319 18.3447 4.33422 18.4575 4.35361C18.5735 4.3693 18.6813 4.3908 18.781 4.4181C18.8837 4.44171 18.9766 4.47125 19.0596 4.50673C19.1423 4.53877 19.1986 4.56755 19.2286 4.59308C19.2621 4.61835 19.2851 4.64267 19.2975 4.66603C19.3134 4.68914 19.3262 4.71595 19.3358 4.74646C19.3454 4.77697 19.3538 4.81278 19.3608 4.85389C19.3713 4.89474 19.3789 4.94102 19.3834 4.99272C19.3891 5.05822 19.3906 5.11535 19.3879 5.16412C19.3887 5.21263 19.3851 5.25106 19.3772 5.2794C19.3692 5.30775 19.3572 5.32945 19.3412 5.34452C19.3251 5.35959 19.305 5.36801 19.2809 5.36981C19.2429 5.37262 19.1806 5.35469 19.0938 5.31602C19.0071 5.27735 18.8976 5.23689 18.7654 5.19465C18.6367 5.15215 18.4876 5.11464 18.318 5.08211C18.1485 5.04957 17.9619 5.04085 17.7583 5.05595C17.5271 5.07309 17.3307 5.1102 17.1689 5.16729C17.0107 5.22412 16.8834 5.29774 16.7871 5.38814C16.694 5.47484 16.6282 5.57686 16.5898 5.69419C16.5549 5.81127 16.5433 5.93702 16.5551 6.07146C16.5731 6.27828 16.6348 6.44717 16.74 6.57815C16.8487 6.70887 16.9831 6.81685 17.1434 6.90212C17.3071 6.98712 17.4903 7.0568 17.693 7.11116C17.8957 7.16552 18.1022 7.22307 18.3124 7.28381C18.5258 7.34085 18.7347 7.40689 18.9393 7.48193C19.1438 7.55697 19.328 7.65781 19.4918 7.78443C19.6592 7.9108 19.7982 8.0705 19.9088 8.26352C20.0226 8.45283 20.0921 8.69227 20.1174 8.98181Z"
              fill="#A3A3A5"
            />
            <path
              d="M22 14.5273C22 16.3074 21.4722 18.0474 20.4832 19.5275C19.4943 21.0075 18.0887 22.1611 16.4441 22.8423C14.7996 23.5234 12.99 23.7017 11.2442 23.3544C9.49835 23.0071 7.89471 22.15 6.63603 20.8913C5.37736 19.6326 4.5202 18.029 4.17293 16.2831C3.82567 14.5373 4.0039 12.7277 4.68509 11.0832C5.36628 9.43865 6.51983 8.03304 7.99988 7.04411C9.47992 6.05518 11.22 5.52734 13 5.52734L13 8.20633C11.7498 8.20633 10.5277 8.57705 9.48824 9.27161C8.44875 9.96617 7.63857 10.9534 7.16015 12.1084C6.68172 13.2634 6.55655 14.5343 6.80044 15.7605C7.04434 16.9867 7.64636 18.113 8.53037 18.997C9.41437 19.881 10.5407 20.483 11.7668 20.7269C12.993 20.9708 14.2639 20.8456 15.4189 20.3672C16.574 19.8888 17.5612 19.0786 18.2557 18.0391C18.9503 16.9996 19.321 15.7775 19.321 14.5273H22Z"
              fill="#A3A3A5"
            />
            <rect x="13" y="13.4023" width="9" height="2.25" fill="#A3A3A5" />
          </svg>
          <p>153.7K</p>
        </div>

        <Link className="logo logo-head flex-row" to="/">
          <div className="logo-container rounded">
            <svg
              viewBox="0 0 65 58"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M32.634 34.7621C35.7903 34.7621 38.349 32.2034 38.349 29.0471C38.349 25.8907 35.7903 23.332 32.634 23.332C29.4776 23.332 26.9189 25.8907 26.9189 29.0471C26.9189 32.2034 29.4776 34.7621 32.634 34.7621Z" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32.6342 17.4297C40.3074 17.4297 47.4356 18.5307 52.8103 20.381C59.2859 22.6104 63.2674 25.9896 63.2674 29.0495C63.2674 32.2381 59.0478 35.8281 52.0938 38.1321C46.8364 39.874 39.918 40.7833 32.6342 40.7833C25.1663 40.7833 18.0946 39.9298 12.778 38.113C6.05145 35.8139 2 32.1774 2 29.0495C2 26.0145 5.80151 22.6613 12.1862 20.4354C17.5808 18.5545 24.885 17.4297 32.6332 17.4297H32.6342Z"
                strokeWidth="2.73408"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.5184 23.2716C26.3518 16.6246 30.8665 10.9997 35.1544 7.26811C40.3207 2.77214 45.2372 1.01139 47.8877 2.53986C50.6501 4.1328 51.6519 9.58171 50.1738 16.7566C49.0573 22.1813 46.3877 28.6284 42.7489 34.9383C39.018 41.4075 34.746 47.1072 30.5165 50.8041C25.1646 55.4826 19.9903 57.1757 17.2807 55.613C14.6515 54.0979 13.646 49.1287 14.9073 42.4857C15.973 36.8728 18.6475 29.9835 22.5172 23.2715L22.5184 23.2716Z"
                strokeWidth="2.73408"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.5286 34.9557C18.6844 28.3162 16.0671 21.5944 14.9746 16.0159C13.6595 9.29465 14.5893 4.15572 17.2375 2.62281C19.9971 1.02519 25.2181 2.87845 30.696 7.74237C34.8377 11.4197 39.0905 16.9513 42.74 23.2552C46.4815 29.7182 49.2858 36.266 50.3767 41.7765C51.7571 48.7499 50.6399 54.0781 47.9328 55.6452C45.3061 57.1658 40.4995 55.5559 35.3742 51.1453C31.0438 47.419 26.4108 41.6611 22.5286 34.9556V34.9557Z"
                strokeWidth="2.73408"
              />
            </svg>
          </div>
          <h1 className="sidebar__logoName">GeniuSparkle</h1>
        </Link>

        {page !== "images/" && (
          <form onSubmit={handleSearch} className={`header__form flex-row`}>
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <svg
              width="20"
              height="20"
              className="header__searchIcon"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                r="6.2"
                transform="matrix(-0.819152 0.573576 0.573576 0.819152 13.4948 12.4952)"
                stroke="#4D4F5C"
                strokeWidth="1"
              />
              <rect
                width="1"
                height="7.13287"
                rx="1"
                transform="matrix(-0.819152 0.573576 0.573576 0.819152 17.6426 16.6729)"
                fill="#4D4F5C"
              />
            </svg>
          </form>
        )}
      </div>

      <div className="header__right flex-row">
        <div
          className="header__balanceUser flex-row"
          onClick={() => history.push("/credits")}
        >
          <svg
            width="26"
            height="26"
            viewBox="0 0 49 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.284 5C39.898 5 45.278 10.38 45.278 16.996V31.35C45.278 37.964 39.898 43.346 33.284 43.346H15.996C9.382 43.346 4 37.964 4 31.35V16.996C4 10.38 9.382 5 15.996 5H33.284ZM33.284 8H15.996C11.036 8 7 12.036 7 16.996V31.35C7 36.31 11.036 40.346 15.996 40.346H33.284C38.244 40.346 42.278 36.31 42.278 31.35V30.79L35.6822 30.7912C31.8882 30.7912 28.8002 27.7052 28.7982 23.9132C28.7982 20.1172 31.8862 17.0292 35.6822 17.0272L42.278 17.026V16.996C42.278 12.036 38.244 8 33.284 8ZM42.278 20.026L35.6822 20.0272C33.5402 20.0292 31.7982 21.7712 31.7982 23.9112C31.7982 26.0492 33.5422 27.7912 35.6822 27.7912L42.278 27.79V20.026ZM36.5974 22.2872C37.4254 22.2872 38.0974 22.9592 38.0974 23.7872C38.0974 24.6152 37.4254 25.2872 36.5974 25.2872H35.9734C35.1454 25.2872 34.4734 24.6152 34.4734 23.7872C34.4734 22.9592 35.1454 22.2872 35.9734 22.2872H36.5974ZM25.37 14.0762C26.198 14.0762 26.87 14.7482 26.87 15.5762C26.87 16.4042 26.198 17.0762 25.37 17.0762H14.572C13.744 17.0762 13.072 16.4042 13.072 15.5762C13.072 14.7482 13.744 14.0762 14.572 14.0762H25.37Z"
              fill="#4D4F5C"
            />
          </svg>

          <strong className="flex-row">100.00</strong>
        </div>
        <a target="_blank" rel="noreferrer" href="https://discord.com/app">
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            className="header__rightMessage"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.9185 20.2173L18.9185 20.2173C18.7281 20.2961 18.4884 20.3464 18.1006 20.3728C17.7074 20.3997 17.2071 20.4 16.5 20.4H12C7.36081 20.4 3.6 16.6392 3.6 12C3.6 7.36081 7.36081 3.6 12 3.6C16.6392 3.6 20.4 7.36081 20.4 12V16.5C20.4 17.2071 20.3997 17.7074 20.3728 18.1006C20.3464 18.4884 20.2961 18.7281 20.2173 18.9185L20.2173 18.9185C19.9738 19.5065 19.5065 19.9738 18.9185 20.2173Z"
              stroke="#4D4F5C"
              strokeWidth="1.3"
            />
            <path
              d="M9 11H15"
              stroke="#4D4F5C"
              strokeWidth="1.3"
              strokeLinecap="round"
            />
            <path
              d="M12 15H15"
              stroke="#4D4F5C"
              strokeWidth="1.3"
              strokeLinecap="round"
            />
          </svg>
        </a>

        <div
          className="header__notification"
          onClick={() =>
            setShowNotifications((showNotifications) => !showNotifications)
          }
        >
          <svg
            width="28"
            height="28"
            className="header__rightMessage"
            // onClick={() => handleHeaderIconClick("notifications")}
            viewBox="0 0 42 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.8364 32.1036C25.6964 34.5855 23.5836 36.5455 21 36.5455C18.4164 36.5455 16.3036 34.5855 16.1636 32.1036H10.2327C8.45091 32.1036 7 30.7036 7 28.9727C7 27.2418 8.45091 25.8418 10.2327 25.8418V19.58C10.2327 15.1636 13.0709 11.2945 17.2327 9.79273V9.65273C17.2327 7.64182 18.9255 6 21 6C23.0873 6 24.7673 7.62909 24.7673 9.65273V9.79273C28.9291 11.2945 31.7673 15.1636 31.7673 19.58V25.8418C33.5491 25.8418 35 27.2418 35 28.9727C35 30.7036 33.5491 32.1036 31.7673 32.1036H25.8364ZM23.6727 32.1036H18.3273C18.4545 33.4273 19.6 34.4582 21 34.4582C22.4 34.4582 23.5455 33.4273 23.6727 32.1036ZM18.6073 11.5491C14.9545 12.5673 12.3836 15.8255 12.3836 19.58V25.8418C12.3836 27 11.4164 27.9291 10.2327 27.9291C9.63455 27.9291 9.15078 28.4 9.15078 28.9727C9.15078 29.5455 9.63455 30.0164 10.2327 30.0164H31.7673C32.3655 30.0164 32.8492 29.5455 32.8492 28.9727C32.8492 28.4 32.3655 27.9291 31.7673 27.9291C30.5836 27.9291 29.6164 27 29.6164 25.8418V19.58C29.6164 15.8255 27.0455 12.5673 23.3927 11.5491L22.6164 11.3327V9.65273C22.6164 8.78727 21.8909 8.08727 21 8.08727C20.1091 8.08727 19.3836 8.78727 19.3836 9.65273V11.3327L18.6073 11.5491Z"
              fill="#4D4F5C"
            />
          </svg>
          <NotificationsPopup showNotifications={showNotifications} />
        </div>

        <div
          className="header__cart header__rightMessage"
          onClick={() => handleHeaderIconClick("cart")}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.9889 2C14.3911 2 16.3755 3.92228 16.6202 6.38082L16.6885 6.38167C18.0211 6.38167 19.6413 7.31112 20.1881 9.91804L20.9133 15.8123C21.1733 17.7147 20.848 19.2406 19.9446 20.3351C19.0458 21.4238 17.6231 22 15.8301 22H8.15807C6.1886 22 4.81649 21.4933 3.96271 20.4519C3.10526 19.4076 2.81852 17.8411 3.11077 15.7969L3.82394 9.98077C4.29264 7.31402 6.00663 6.38167 7.3337 6.38167C7.44827 5.27218 7.92463 4.2167 8.68035 3.42555C9.54884 2.51926 10.7463 2 11.9696 2H11.9889ZM16.6885 7.82942H7.3337C6.92841 7.82942 5.57377 8.00122 5.18502 10.2057L4.47553 15.9967C4.24485 17.621 4.42314 18.7966 5.00673 19.5079C5.58296 20.2106 6.61411 20.5522 8.15807 20.5522H15.8301C16.7933 20.5522 18.1084 20.3505 18.9024 19.3873C19.5329 18.6238 19.7498 17.4869 19.5476 16.0073L18.8317 10.1661C18.5265 8.72702 17.7215 7.82942 16.6885 7.82942ZM14.6692 10.5165C15.0497 10.5165 15.3796 10.8408 15.3796 11.2404C15.3796 11.64 15.092 11.9643 14.7115 11.9643H14.6692C14.2887 11.9643 13.9799 11.64 13.9799 11.2404C13.9799 10.8408 14.2887 10.5165 14.6692 10.5165ZM9.31118 10.5165C9.69165 10.5165 10.0216 10.8408 10.0216 11.2404C10.0216 11.64 9.73301 11.9643 9.35253 11.9643H9.31118C8.9307 11.9643 8.6219 11.64 8.6219 11.2404C8.6219 10.8408 8.9307 10.5165 9.31118 10.5165ZM11.9861 3.44775H11.9723C11.1075 3.44775 10.2648 3.81355 9.65361 4.45152C9.15577 4.97201 8.83017 5.65624 8.72485 6.38122L15.2309 6.38149C14.9947 4.7231 13.6292 3.44775 11.9861 3.44775Z"
              fill="#4D4F5C"
            />
          </svg>
          {cartItems.length !== 0 && (
            <div className="header__cartItem item-center">
              {cartItems.reduce((a, q) => a + q.qty, 0)}
            </div>
          )}
        </div>

        {openTopupPopup && (
          <TopupGiftPopup type="Topup" setOpenPopup={setOpenTopupPopup} />
        )}

        <button
          onClick={() =>
            (window.location.href = "https://gs-landing-page.pages.dev/donate")
          }
          className="btn primary header__btnDonate"
        >
          Donate
          <svg
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8.612 2.347L8 2.997L7.388 2.347C5.698 0.552003 2.958 0.552003 1.268 2.347C-0.421996 4.142 -0.421996 7.053 1.268 8.849L1.88 9.499L8 16L14.12 9.498L14.732 8.848C16.422 7.053 16.422 4.142 14.732 2.346C13.042 0.551003 10.302 0.551003 8.612 2.347Z" />
          </svg>
        </button>

        <div className="flex-row">
          <ProfileCard />
          <div className="header__dropbox">
            <select name="" id="">
              <option value="">Home</option>
              <option value="">Ipsum</option>
              <option value="">Quia</option>
              <option value="">Voila</option>
              <option value="">Laqoro</option>
            </select>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
